import React, { useEffect } from "react";
import { Container, Row, Col, Card, CardBody, CardTitle, CardText } from "reactstrap";
import DOMPurify from "dompurify";
import content from "./content.json";

const isValidUrl = (url) => {
  try {
    const parsedUrl = new URL(url);
    return ['https:', 'http:'].includes(parsedUrl.protocol);
  } catch {
    return false;
  }
};

const ProgramKreatifitasMahasiswa = () => {
  useEffect(() => {
    // Memastikan halaman tidak dimuat dalam iframe
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }
    
  }, []);

  return (
    <div className="pkm-upi">
      <header className="header-section">
        <div className="header-content">
          <h2>{DOMPurify.sanitize(content.header)}</h2>
          <hr className="header-line" />
        </div>
      </header>

      <Container className="mt-4" style={{ margin: "50px auto" }}>
        <Row>
          <Col>
            <Card style={{ border: "none" }}>
              <CardBody>
                <CardTitle tag="h6">
                  <strong>{DOMPurify.sanitize(content.date)}</strong>
                </CardTitle>
                <CardText>{DOMPurify.sanitize(content.details)}</CardText>
                <CardText>
                  Pedoman PKM 2020 dapat diunduh di laman:
                  <ul>
                    {content.links.map((link, index) =>
                      isValidUrl(link.url) ? (
                        <li key={index}>
                          <a
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {DOMPurify.sanitize(link.text)}
                          </a>
                        </li>
                      ) : (
                        <li key={index}>Invalid URL</li>
                      )
                    )}
                  </ul>
                </CardText>
                <CardText>
                  {DOMPurify.sanitize(
                    "Untuk info lebih lanjut silahkan hubungi LPPM (F8) atau PD 3 masing-masing Fakultas."
                  )}
                </CardText>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <hr />
      </Container>
    </div>
  );
};

export default ProgramKreatifitasMahasiswa;
